import { Box, Separator } from "@chakra-ui/react-v3";
import { MedicationRowData } from "../tables/medication";
import { SidePanelLayout } from "../components/side-panel-sections/side-panel-layout";
import { MedicationDisplay } from "../components/medication-display";
import { ResourceAnalysis } from "../components/resource-analysis";
import {
  DocumentsSection,
  WithExtension,
} from "../components/side-panel-sections/documents-section";

export type MedicationSidePanelContentProps = {
  data: MedicationRowData;
};

export function MedicationSidePanelContent({ data }: MedicationSidePanelContentProps) {
  const resourcesForDocuments: WithExtension[] =
    "events" in data.originalData
      ? data.originalData.events.map(e => e.resource as WithExtension)
      : "resources" in data.originalData
      ? (data.originalData.resources as WithExtension[])
      : [];

  return (
    <SidePanelLayout
      title="Medication"
      subtitle={data.medication}
      metadata={`Last Fill: ${data.lastFillDate}`}
    >
      <ResourceAnalysis />

      <Separator borderColor="border" />

      {/* Use existing MedicationDisplay component */}
      <Box>
        <MedicationDisplay resource={data.originalData} />
      </Box>

      <Separator borderColor="border" />

      <DocumentsSection resources={resourcesForDocuments} resourceType="Medication" />
    </SidePanelLayout>
  );
}
